var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.281 18.2188C19.3507 18.2885 19.406 18.3712 19.4437 18.4623C19.4814 18.5533 19.5008 18.6509 19.5008 18.7494C19.5008 18.848 19.4814 18.9456 19.4437 19.0366C19.406 19.1277 19.3507 19.2104 19.281 19.2801C19.2114 19.3497 19.1286 19.405 19.0376 19.4427C18.9465 19.4804 18.849 19.4999 18.7504 19.4999C18.6519 19.4999 18.5543 19.4804 18.4632 19.4427C18.3722 19.405 18.2895 19.3497 18.2198 19.2801L12.0004 13.0598L5.78104 19.2801C5.64031 19.4208 5.44944 19.4999 5.25042 19.4999C5.05139 19.4999 4.86052 19.4208 4.71979 19.2801C4.57906 19.1393 4.5 18.9485 4.5 18.7494C4.5 18.5504 4.57906 18.3595 4.71979 18.2188L10.9401 11.9994L4.71979 5.78007C4.57906 5.63933 4.5 5.44846 4.5 5.24944C4.5 5.05042 4.57906 4.85955 4.71979 4.71882C4.86052 4.57808 5.05139 4.49902 5.25042 4.49902C5.44944 4.49902 5.64031 4.57808 5.78104 4.71882L12.0004 10.9391L18.2198 4.71882C18.3605 4.57808 18.5514 4.49902 18.7504 4.49902C18.9494 4.49902 19.1403 4.57808 19.281 4.71882C19.4218 4.85955 19.5008 5.05042 19.5008 5.24944C19.5008 5.44846 19.4218 5.63933 19.281 5.78007L13.0607 11.9994L19.281 18.2188Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.0102ff38d3b65b22ebcfe8f902fced05.svg";
export { ForwardRef as ReactComponent };